export const GET_USER_LIST = '@USER_LIST/GET_USER_LIST'
export const BLOCK_OR_ACTIVE_USER = '@USER_LIST/BLOCK_OR_ACTIVE_USER'

export const GET_ALL_PORTFOLIO_BY_USER_ID = '@USER_LIST/GET_ALL_PORTFOLIO_BY_USER_ID'
export const GET_INFO_USER_AND_PORTFOLIO = '@USER_LIST/GET_INFO_USER_AND_PORTFOLIO'
